import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { AppContext, AccountContext, WidgetsContext } from '../GlobalContex';
import useNotifications from '../hooks/useNotifications';

export default function Auth({ children }) {
  const { setIsLoading, isEmbeded } = useContext(AppContext);
  const { account, isAuthorized, embededAuth } = useContext(AccountContext);
  const { loadWidgets } = useContext(WidgetsContext);

  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { widgetId } = useParams();
  const notification = useNotifications();

  useEffect(() => {
    setIsLoading(true);
    const activeAuthMethod = () => (isEmbeded() ? embededAuth() : isAuthorized());
    activeAuthMethod()
      .then(isAuth => {
        if (!isAuth) {
          navigate('/register');
          return;
        }

        if (widgetId) {
          navigate(location.pathname);
        } else {
          return loadWidgets()
            .then(widgets => {
              if (isEmbeded()) {
                navigate(location.pathname);
                return;
              }

              if (!widgets.length) {
                navigate('/widget-creator');
              } else if (location.pathname === '/') {
                navigate('/home');
              }
            })
            .catch(err => {
              notification.error(err.message);
              if (!isEmbeded()) {
                navigate('/home');
              }
            });
        }
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        setIsLoaded(true);
        setIsLoading(false);
      });
  }, [account]);

  return isLoaded ? children : null;
}
